module.exports = __webpack_public_path__ + "c.no2.c8ea5b4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/c.no2.jpg
// module id = 6nNZ
// module chunks = 0